import request from './utils';
import * as ROUTES from 'src/api/routes';

export async function getSurveyDefinitions() {
    const response = await request({ ...ROUTES.GET_SURVEY_DEFINITIONS });

    return { result: response.data.result || [], count: response.data.count || 0 };
}
